import React, { useEffect } from "react";
import { firebase } from 'components/Firebase/firebase';
import PropTypes from "prop-types";

// core components
import GridContainer from "components/grid/gridContainer.js";
import GridItem from "components/grid/gridItem.js";
import Button from '@material-ui/core/Button';

import landingPageStyle from "assets/jss/views/landingPage.js";
import CarouselSection from "views/components/carouselSection";
import { useHistory } from "react-router-dom";
import { Trans, useTranslation } from 'react-i18next';
import i18n from 'i18n';
import jss from 'jss';
import rtl from 'jss-rtl';


export default function LandingPage(props) {
    let widgetId = props.match.params.widgetId;
    const { changeColor } = props;

    const classes = landingPageStyle();
    useTranslation();

    let history = useHistory();
    let visited = localStorage.getItem('visitedWidget' + widgetId) || false;
    if (visited) {//redirect
        if (widgetId)
            history.push("/facilityView/" + widgetId);
    }

    const saveCookiesAsVisited = (event) => {
        if (widgetId) {
            localStorage.setItem('visitedWidget' + widgetId, true);
            history.push("/facilityView/" + widgetId);
        }
    };

    function checkHex(value) {
        return /^#([A-Fa-f0-9]{3}$)|([A-Fa-f0-9]{6}$)/.test(value)
    }

    useEffect(() => {
        if (!widgetId) return;
        firebase.database().ref('WIDGET/' + widgetId).on("value", function (snapshot) {
            if (!snapshot.exists()) {
                return;
            }
            if (snapshot.val().language) {
                i18n.changeLanguage(snapshot.val().language);
                if (i18n.dir(snapshot.val().language) === 'rtl')
                    jss.use(rtl());
            }
            if (snapshot.val().fontColor) {
                if (checkHex(snapshot.val().fontColor))
                    changeColor(snapshot.val().fontColor);
                else {
                    console.log('invalid hex color');
                }
            }
            else {
                changeColor('#d11f2e');
            }
            //setLogo(snapshot.val().logo ? snapshot.val().logo : null);
        });
    }, [widgetId]);

    return (
        <div className={classes.landingDiv}>
            <CarouselSection />
            <GridContainer className={classes.textCenter} justify="center">
                <GridItem xs={12} sm={12} md={12}>
                    <Button
                        disabled={!widgetId}
                        onClick={saveCookiesAsVisited}
                        className={classes.link}
                        color="primary"
                        size="large"
                        variant="contained"
                    >
                        <Trans i18nKey="getStartButton" />
                    </Button>
                </GridItem>
            </GridContainer>
        </div>
    );
}

LandingPage.propTypes = {
    changeColor: PropTypes.func.isRequired,
};